<script setup>
    import { ref, computed, onMounted, getCurrentInstance, inject, nextTick } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import _ from "lodash";
    import Loading from 'vue3-loading-overlay';
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import { useMatchingUpdateStore} from "../../../user/stores/matching/matchingUpdateStore";
    import adminCorporationService from "../../services/corporation/adminCorporationService";
    import adminMatchingService from "../../services/matching/adminMatchingService";
    import mypageMatchingService from "../../../user/services/mypage/mypageMatchingService";
    import mypageProposalService from "../../../user/services/mypage/mypageProposalService";
    import jobFairCorpService from "../../../user/services/jobFair/jobFairCorpService";
    import fileService from "../../../../services/fileService";
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue'
    import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
    import MyPageResumeModal from "../../../user/components/modal/mypage/MyPageResumeModal.vue";
    import MypageProposalContentModal from "../../../user/views/mypage/proposal/MypageProposalContentModal.vue";
    import JobFairJobNoticeModal from "../../../user/components/modal/jobFair/JobFairJobNoticeModal.vue";
    import JobFairResumeModal from "@/pages/user/components/modal/jobFair/JobFairResumeModal.vue";
    import KSAPrimaryButton from "../../../../components/ui-components/button/KSAPrimaryButton.vue";
    import moment from "moment";
    import mypageJobFairService from "../../../user/services/mypage/jobFair/mypageJobFairService";
    import { useAlertStore } from "../../../../stores/alertStore";
    import CorpJobFairTabView from './jobFair/CorpJobFairTabView.vue';

    const { $alert, $confirm } = useAlertStore();

    const route = useRoute();
    const router = useRouter();
    const loadingStore = usePageLoadingStore();
    const matchingUpdateStore = useMatchingUpdateStore();
    const loaded = ref(false);
    const { $regex, $desiredJob, $interests, $corpState, $ojfStateGb, $adminJoinStateGb, $bizNum, $phoneNum, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $gb } = getCurrentInstance().appContext.config.globalProperties;
    
    const tabRef = ref(null);
    const tabOptions = [
      {label:'기본 정보', value:1},
      {label:'재직자 가입 현황', value:2},
      {label:'상시채용관 현황', value:3},
    ];

    const interests = ref($interests);                // 관심 카테고리 - 재직자 가입 현황 tab
    const desiredJob = ref($desiredJob);              // 직무 - 재직자 가입 현황 tab

    // 초기화 버튼 처리를 위한 ref 지정
    const desiredJobListRef = ref(null);        // 직무 - 재직자 가입 현황 tab
    const interestsListRef2 = ref(null);        // 관심 카테고리 - 재직자 가입 현황 tab

    // 데이터
    const corporation = ref({
      corpId: '',
    })  // 기업 기본 정보
    const corpEmpList = ref([]);        // 재직자 목록 - 재직자 가입 현황 tab
    const corpList1 = ref([]);          // 상시채용관 현황 - 채용공고 관리 및 입사지원 현황
    const corpList2 = ref([]);          // 상시채용관 현황 - 관심인재
    const corpList3 = ref([]);          // 상시채용관 현황 - 보낸 면접제안
    const checkMasterYn = ref(false);   // 마스터 회원 - 재직자 가입 현황 tab


    const corpUpdate = ref({
      ojfId: 0,
      bizNum: '', // 사업자등록번호
      corpName: '', // 기업명
      ceoName: '', // 대표자명
      residenceArea1: '', // 사업장소재지1
      residenceArea2: '', // 사업장소재지2
      bizType: '', // 업종
      industryGb: '', // 산업구분
      industryText: '', // 사업구분 기타
      corpGb: '', // 기업형태
      corpText: '', // 기업형태 기타
      foundYm: '', // 창립연월
      employeeNumGb: '', // 사원수(인원구분)
      salesAmtGb: "00", // 매출액
      corpPublicYn: '', // 상장여부
      corpPublicGb: '',// 상장구분
      corpPublicText: '', // 상장구분 기타
      homeUrl: '', // 홈페이지
      ciImgName: '', // 로고이미지명
      ciImgSize: '', // 로고이미지용량
      ciImgDir: '', // 로고이미지위치
      bizLicenseName: '', // 사업자등록증명
      bizLicenseSize: '', // 사업자등록증용량
      bizLicenseDir: '', // 사업자등록증위치
      corpIntro: '', // 기업소개
      corpHistory: '', // 주요연혁
      corpIntroName: '', // 기업소개서명
      corpIntroSize: '', // 기업소개서용량
      corpIntroDir: '', // 기업소개서위치
    });
    const errorInputCorp = ref({
      bizNum: '', // 사업자등록번호
      corpName: '', // 기업명
      ceoName: '', // 대표자명
      residenceArea: '', // 사업장소재지
      bizType: '', // 업종
      industryGb: '', // 산업군
      corpGb: '', // 기업형태
      foundYm: '', // 창립연월
      employeeNumGb: '', // 사원수
      salesAmtGb: '', // 매출액
      corpPublicYn: '', // 상장여부
      corpPublicGb: '', // 상장구분
      ciImg: '', // 로고이미지(CI)
      bizLicense: '', // 사업자등록증
    });

    const VIEW = 'VIEW'; // 기본정보
    const UPDATE = 'UPDATE'; // 기본정보 수정
    const BASIC = 'BASIC'; // 상시채용관 현황 : 채용공고 관리 및 입사지원 현황
    const RETRIEVE_APPLICANT = 'RETRIEVE_APPLICANT' // 상시채용관 현황 : 채용공고 관리 및 입사지원 현황 - 입사지원
    const viewMode = ref(VIEW);

    // s : 기업정보 관리
    // 조회
    const retrieveCorporation = () => {
      loadingStore.loading = true;
      mypageJobFairService.retrieveCorporation(corporation.value.corpId)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            corpUpdate.value = result;

            // 사업자등록번호
            if(result.bizNum ) {
              const bizNum = result.bizNum;
              if(bizNum) {
                result.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
              }
            }

            // 사업장소재지
            if(result.residenceArea1 && result.residenceArea2) {
              residenceAreaRef.value.initSelectedOption(result.residenceArea1, result.residenceArea2)
            }

            // 창립연월
            if(result.foundYm ) {
              const foundYm = result.foundYm;
              if(foundYm) {
                result.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
              }
            }

            // KSACKEditor는 modelValue 변경을 자동 반영하지 않아 조회 후 직접 주입이 필요함
            nextTick(() => {
              corpIntroEditorRef.value?.init(result.corpIntro || '');
              corpHistoryEditorRef.value?.init(result.corpHistory || '');
            });
          }
        }).catch( (error) =>  {
        console.log(error);
        loadingStore.loading = false;
      });
    }

    // 사업자등록번호
    const bizNumInput = ref('')

    const formatBizNum = (event) => {
      validateText('bizNum', event.target.value);

      // 숫자만 필터링
      bizNumInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

      // YYYY.MM 형식으로 포맷팅
      if (bizNumInput.value.length >= 5) {
        corpUpdate.bizNum = `${bizNumInput.value.slice(0, 3)}-${bizNumInput.value.slice(0,2)}-${bizNumInput.value.slice(5)}`
      } else {
        corpUpdate.bizNum = bizNumInput.value
      }
    }

    // 사업장소재지
    const onSelectedArea1Option = (option) => {
      corpUpdate.value.residenceArea1 = option;
      errorInputCorp.value.residenceArea = '';
    }

    const onSelectedArea2Option = (option) => {
      corpUpdate.value.residenceArea2 = option;
      errorInputCorp.value.residenceArea = '';
    }

    // 상장여부 초기화
    const resetCorpPublic = (val) => {
      if (val === 'N') {
        corpUpdate.value.corpPublicGb = ''
        corpUpdate.value.corpPublicText = ''
      }
    }

    // 상장 기타 초기화
    const resetCorpPublicText = (val) => {
      if (val === '05') {
        corpUpdate.value.corpPublicText = ''
      }
    }

    // 산업군 기타 초기화
    const resetIndustryText = (val) => {
      if (val === '06') {
        corpUpdate.value.industryText = ''
      }
    }

    // 기업형태 기타 초기화
    const resetCorpText = (val) => {
      if (val === '05') {
        corpUpdate.value.corpText = ''
      }
    }

    // 로고이미지(CI) 업로드
    const uploadFileCiImg = (corpUpdate) => {
      errorInputCorp.value.ciImg = '';
      const input = document.createElement('input');
      input.type= 'file';
      input.click();

      input.addEventListener('change', function(event){
        // console.log(event.target.files);
        const file = event.target.files[0];

        let paramObj = {
          container: 'public',
          folder: 'ciImg',
          file,
        }
        fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              corpUpdate.ciImgName = result.originalFilename;
              corpUpdate.ciImgSize = result.fileSize;
              corpUpdate.ciImgDir = result.blobUrl;
            }
          }).catch( (error) =>  {
          console.log(error);
        });
      });
    }

    // 로고이미지(CI) 삭제
    const removeFileCiImg = (corpUpdate) => {
      corpUpdate.ciImgName = '';
      corpUpdate.ciImgSize = '';
      corpUpdate.ciImgDir = '';
      errorInputCorp.value.ciImg = '';
    }

    // 사업자등록증 업로드
    const uploadFileBizLicense = (corpUpdate) => {
      errorInputCorp.value.bizLicense = '';
      const input = document.createElement('input');
      input.type= 'file';
      input.click();

      input.addEventListener('change', function(event){
        // console.log(event.target.files);
        const file = event.target.files[0];

        let paramObj = {
          container: 'private',
          folder: 'bizLicense',
          file,
        }
        fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              corpUpdate.bizLicenseName = result.originalFilename;
              corpUpdate.bizLicenseSize = result.fileSize;
              corpUpdate.bizLicenseDir = result.blobUrl;
            }
          }).catch( (error) =>  {
          console.log(error);
        });
      });
    }

    // 사업자등록증 삭제
    const removeFileBizLicense = (corpUpdate) => {
      corpUpdate.bizLicenseName = '';
      corpUpdate.bizLicenseSize = '';
      corpUpdate.bizLicenseDir = '';
      errorInputCorp.value.bizLicense = '';
    }

    // 기업소개서 업로드
    const uploadFileCorpIntro = (corpUpdate) => {
      const input = document.createElement('input');
      input.type= 'file';
      input.click();

      input.addEventListener('change', function(event){
        // console.log(event.target.files);
        const file = event.target.files[0];

        let paramObj = {
          container: 'private',
          folder: 'corpIntro',
          file,
        }
        fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              corpUpdate.corpIntroName = result.originalFilename;
              corpUpdate.corpIntroSize = result.fileSize;
              corpUpdate.corpIntroDir = result.blobUrl;
            }
          }).catch( (error) =>  {
          console.log(error);
        });
      });
    }

    // 기업소개서 삭제
    const removeFileCorpIntro = (corpUpdate) => {
      corpUpdate.corpIntroName = '';
      corpUpdate.corpIntroSize = '';
      corpUpdate.corpIntroDir = '';
    }

    // 취소
    const clickCancel = () => {
      setViewMode(VIEW)
      retrieveCorpDetail();

      $alert("수정이 취소되었습니다.");
    }

    // 수정 완료
    const updateCorporation = async () => {
      let isInvalid = false;
      let corpId = corporation.value.corpId;

      // 기본 기본 정보
      // 사업자등록번호
      const { corpName } = corpUpdate.value;
      errorInputCorp.value.bizNum = '';

      const bizNum = corpUpdate.value.bizNum ? corpUpdate.value.bizNum.replace('-','').replace('-','') : corpUpdate.value.bizNum;
      if(!bizNum || bizNum.length !== 10) {
        errorInputCorp.value.bizNum = !bizNum ? '사업자등록번호를 입력하세요.' : '10자리 숫자를 입력하세요.';
        isInvalid = true;
      }

      // 대표자명, 사업장소재지, 업종
      const { ceoName, residenceArea1, residenceArea2, bizType } = corpUpdate.value;
      errorInputCorp.value.ceoName = '';
      errorInputCorp.value.residenceArea = '';
      errorInputCorp.value.bizType = '';

      // 대표자명
      if(!ceoName) {
        errorInputCorp.value.ceoName = '대표자명을 입력하세요.';
        isInvalid = true;
      }

      //사업장소재지
      if((residenceArea1 === '' || residenceArea1 === '시/도 선택') ||
        (residenceArea2 === '' || residenceArea2 === '시/구/군 선택') ) {
        errorInputCorp.value.residenceArea = (residenceArea1 === '' || residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
        isInvalid = true;
      }

      // 업종
      if(!bizType) {
        errorInputCorp.value.bizType = '업종을 입력하세요.';
        isInvalid = true;
      }

      // 산업구분, 기업형태, 창립연월, 사원수(인원구분), 매출액
      const { industryGb, corpGb, employeeNumGb, salesAmtGb } = corpUpdate.value;
      errorInputCorp.value.industryGb = '';
      errorInputCorp.value.corpGb = '';
      errorInputCorp.value.foundYm = '';
      errorInputCorp.value.employeeNumGb = '';
      errorInputCorp.value.salesAmtGb = '';

      // 산업군
      let industryText = corpUpdate.value.industryText;
      if(!industryGb) {
        errorInputCorp.value.industryGb = '산업군을 선택하세요.';
        isInvalid = true;
      } else if(industryGb === '06' && !industryText) {
        errorInputCorp.value.industryGb = '기타 산업군을 입력하세요.';
        isInvalid = true;
      } else if (industryGb !== '06') {
        industryText = '';
      }

      // 기업형태
      let corpText = corpUpdate.value.corpText;
      if(!corpGb) {
        errorInputCorp.value.corpGb = '기업형태를 선택하세요.';
        isInvalid = true;
      } else if(corpGb === '05' && !corpText) {
        errorInputCorp.value.corpGb = '기타 기업형태를 입력하세요.';
        isInvalid = true;
      } else if(corpGb !== '05') {
        corpText = '';
      }

      // 창립연월
      const foundYm = moment(corpUpdate.value.foundYm.replace('.', '')).format("YYYYMM")
      if(!foundYm) {
        errorInputCorp.value.foundYm = '창립연월을 입력하세요.';
        isInvalid = true;
      } else if (foundYm) {
        console.log(foundYm);
        if(foundYm.length !== 6) {
          errorInputCorp.value.foundYm = '기간을 YYYY.MM 형식으로 입력하세요.';
          isInvalid = true;
        } else if(foundYm === 'Invalid date'  // 존재하지 않은 기간
          // || Number(nowYm) < Number(startYm)  // 미래 기간
        ) {
          errorInputCorp.value.foundYm = '올바른 기간을 입력하세요.';
          isInvalid = true;
        }
      }

      // 사원수(인원구분)
      if(!employeeNumGb || employeeNumGb === '00') {
        errorInputCorp.value.employeeNumGb = '사원수를 선택하세요.';
        isInvalid = true;
      }

      // 매출액
      if(!salesAmtGb || salesAmtGb === '00') {
        errorInputCorp.value.salesAmtGb = '매출액을 선택하세요.';
        isInvalid = true;
      }

      // 상장, 홈페이지 url
      const { corpPublicYn, corpPublicGb, homeUrl } = corpUpdate.value;
      errorInputCorp.value.corpPublicYn = '';
      errorInputCorp.value.corpPublicGb = '';

      // 상장
      let corpPublicText = corpUpdate.value.corpPublicYn;
      if(!corpPublicYn) {
        errorInputCorp.value.corpPublicYn = '상장여부를 선택하세요.';
        isInvalid = true;
      } else if(corpPublicYn === 'Y' && !corpPublicGb) {
        errorInputCorp.value.corpPublicGb = '상장여부를 선택하세요.';
        isInvalid = true;
      } else if(corpPublicYn === 'Y' && corpPublicGb === '05' && !corpPublicText) {
        errorInputCorp.value.corpPublicGb = '기타 상장을 입력하세요.';
        isInvalid = true;
      } else if(corpPublicYn === 'Y' && corpPublicGb !== '05') {
        corpPublicText = '';
      }

      // 로고이미지(CI)
      const { ciImgName, ciImgSize, ciImgDir } = corpUpdate.value;
      errorInputCorp.value.ciImg = '';

      if(!ciImgName || !ciImgSize || !ciImgDir) {
        errorInputCorp.value.ciImg = '로고이미지 파일을 선택하세요.';
        isInvalid = true;
      }

      // 사업자등록증
      const { bizLicenseName, bizLicenseSize, bizLicenseDir } = corpUpdate.value;
      errorInputCorp.value.bizLicense = '';

      if(!bizLicenseName || !bizLicenseSize || !bizLicenseDir) {
        errorInputCorp.value.bizLicense = '사업자등록증 파일을 선택하세요.';
        isInvalid = true;
      }

      // 기업 추가 정보 (기업 소개, 주요 연혁, 기업 소개서)
      const { corpIntro, corpHistory, corpIntroName, corpIntroSize, corpIntroDir } = corpUpdate.value;


      // 참가 신청 담당자 정보
      const { chargeName, chargeDepart, chargeJob, chargeCompanyNum, chargePhoneNum } = corpUpdate.value;
      errorInputCorp.value.chargeName  = '';
      errorInputCorp.value.chargeDepart  = '';
      errorInputCorp.value.chargeJob  = '';
      errorInputCorp.value.chargeCompanyNum  = '';
      errorInputCorp.value.chargePhoneNum  = '';
      errorInputCorp.value.chargeEmail  = '';

      // 성명
      if(!chargeName) {
        errorInputCorp.value.chargeName = '성명을 입력하세요.';
        isInvalid = true;
      }

      // 부서
      if(!chargeDepart) {
        errorInputCorp.value.chargeDepart = '부서를 입력하세요.';
        isInvalid = true;
      }

      // 직위
      if(!chargeJob) {
        errorInputCorp.value.chargeJob = '직위를 입력하세요.';
        isInvalid = true;
      }

      // 회사 직통번호
      if(!chargeCompanyNum) {
        errorInputCorp.value.chargeCompanyNum = '회사 직통번호를 입력하세요.';
        isInvalid = true;
      }

      // 휴대전화
      if(!chargePhoneNum || chargePhoneNum.length !== 13) {
        errorInputCorp.value.chargePhoneNum = '휴대폰 번호를 입력하세요.';
        isInvalid = true;
      } else if(!$regex.phoneNum.test(chargePhoneNum)) {
        errorInputCorp.value.chargePhoneNum = '휴대폰 번호를 숫자로만 입력하세요.';
        isInvalid = true;
      }

      // 이메일 형식 확인
      const chargeEmail = corpUpdate.value.chargeEmail.trim()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      // 이메일
      if(!chargeEmail) {
        errorInputCorp.value.chargeEmail = '이메일을 입력하세요.';
        isInvalid = true;
      } else if (!emailRegex.test(chargeEmail)) {
        errorInputCorp.value.chargeEmail = '유효한 이메일 형식을 입력하세요.';
        isInvalid = true;
      }

      // 저장 처리
      if(!isInvalid) {
        const ok = await $confirm("저장하시겠습니까?")
        let paramObj = {
          corpId, bizNum, corpName, ceoName, residenceArea1, residenceArea2,
          bizType, industryGb, industryText, corpGb, corpText,
          foundYm, employeeNumGb, salesAmtGb, corpPublicYn, corpPublicGb, corpPublicText,
          homeUrl, ciImgName, ciImgSize, ciImgDir,
          bizLicenseName, bizLicenseSize, bizLicenseDir,
          corpIntro, corpHistory, corpIntroName, corpIntroSize, corpIntroDir,
          chargeName, chargeDepart, chargeJob, chargeCompanyNum,
          chargePhoneNum, chargeEmail,
        }

        if(!ok) {
          return -1;
        } else {
        mypageJobFairService.updateJobFairCorp(paramObj)
          .then(async (res) => {
            loadingStore.loading = false;

            if (res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;

              await $alert("수정이 완료되었습니다.");

              setViewMode(VIEW);
              retrieveCorpDetail();
            }
          }).catch((res) => {
            loadingStore.loading = false;
            $alert([res.response.data.result.message]);
          });
        }
      }
    }

    const residenceAreaRef = ref(null);
    const corpIntroEditorRef = ref(null);
    const corpHistoryEditorRef = ref(null);
    // e : 기업정보 관리


    onMounted(()=>{
        loaded.value = false;
        const { id } = route.params;
        if(!id) {
            goBack();
        } else {
            corporation.value.corpId = id;
            retrieveCorpDetail();
            retrieveCorpEmpList();
            //retrieveCorpMatchingList();
        }

        const tabFromQuery = Number(route.query.tab);
        if (tabFromQuery && tabOptions.some(opt => opt.value === tabFromQuery)) {
          tabIndex.value = tabFromQuery;
          if(tabRef.value) {
            tabRef.value.init(tabFromQuery);
          }
        }
    })

    const tabIndex = ref(1)
    const tabIndex2 = ref(1)

    const jobNoticeModal = ref(null); // 채용공고

    const searchDurationGbRef2 = ref([]);       // 재직자 가입 현황 tab

    const searchOpen = ref(true);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(0);
    const totalCount = ref(0);

    const searchInput2 = ref({ // 재직자 가입 현황 tab 검색조건
        desiredJobList: ['회로/시스템 설계','장비 운영/유지보수/개선','장비/부품 개발','소재 개발 및 평가','공정 개발 및 평가','패키지 개발','제품 평가 및 분석','반도체 SW 개발','기타'],
        interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
        sex: '00',
        corpMasterYn: false,
        searchType: 'name', // code 회원코드,name 이름, id 아이디, email 이메일
        searchInput: '',
        searchDurationGb: 'C', // (L 최근 접속일 C 가입일)
        searchDurationType: 'all',
        startYmd: '',
        endYmd: '',
    });

    // START : 공통
    const pageSizeGroup = ref([
        { label:'10개씩 보기', value: '10' },
        { label:'30개씩 보기', value: '30' },
        { label:'50개씩 보기', value: '50' },
        { label:'100개씩 보기', value: '100' },
    ])
    // END : 공통

    // START : 재직자 가입 현황 TAB
    // 검색조건 - 성별. 재직자 가입 현황 tab
    const sexGroup = ref([
        { label:'전체', value: '00' },
        { label:'남자', value: '01' },
        { label:'여자', value: '02' },
    ]);

    // 검색조건 - 기간 (C 가입일, C 최근 접속일). 재직자 가입 현황 tab.
    const searchDurationGbGroup = ref([
        { label:'가입일', value: 'C' },
        { label:'최근 접속일', value: 'L' },
    ])

    // 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색). 재직자 가입 현황 tab
    const searchDurationTypeGroup = ref([
        { label:'모든 기간', value: 'all' },
        { label:'기간 검색', value: 'term' },
    ])

    // 검색조건 - 검색기준 (재직자명, 아이디, 핸드폰번호 뒷4자리, 이메일). 재직자 가입 현황 tab
    const searchTypeGroup2 = ref([
        { label:'재직자명', value: 'name', placeholder: '이름을 입력해 주세요.' },
        { label:'아이디', value: 'id', placeholder: '아이디를 입력해 주세요.' },
        { label:'핸드폰번호', value: 'phone', placeholder: '"-"를 제외한 핸드폰번호 뒷4자리를 입력해 주세요.' },
        { label:'이메일', value: 'email', placeholder: '이메일을 입력해 주세요.' },
    ]);
    const searchInputPlaceholder2 = computed(()=>{
        const option = _.find(searchTypeGroup2.value, { value: searchInput2.value.searchType });
        if(option) {
            return option.placeholder;
        } else {
            return '';
        }
    });
    // END : 재직자 가입 현황 TAB

    // s: 기본 정보
    // 기업 기본 정보 조회
    const retrieveCorpDetail = async () => {
        loaded.value = false;
        //loadingStore.loading = true;
        mypageJobFairService.retrieveCorporation(corporation.value.corpId)
          .then( async (res) => {
            //loadingStore.loading = false;
            loaded.value = true;
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              corporation.value = res.data.result;
            } else {
            }
          }).catch( (res) =>  {
            console.log(res);
            //loadingStore.loading = false;
            loaded.value = true;
          });
    }
    // e: 기본 정보

    // s: 재직자 가입 현황
    // 재직자 가입 현황 조회
    const retrieveCorpEmpList = () => {
        let paramObj = {
            corpId: corporation.value.corpId,
            searchDesiredJobs: _.map(searchInput2.value.desiredJobList).join(','),
            searchInterests: _.map(searchInput2.value.interestsList).join(','),
            searchSex: searchInput2.value.sex,
            searchCorpMasterYn: searchInput2.value.corpMasterYn ? 'Y' : 'N',
            searchType: searchInput2.value.searchType,
            searchInput: searchInput2.value.searchInput,
            searchDurationGb: searchInput2.value.searchDurationGb,
            startYmd: searchInput2.value.searchDurationType === 'all' ? '' : searchInput2.value.startYmd,
            endYmd: searchInput2.value.searchDurationType === 'all' ? '' : searchInput2.value.endYmd,
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        //loadingStore.loading = true;
        loaded.value = false;
        adminCorporationService.retrieveCorpEmpListPaging(paramObj)
            .then(async (res) => {
                //loadingStore.loading = false;
                loaded.value = true;
                // console.log(res);
                if (res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    corpEmpList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch((res) => {
            console.log(res);
            //loadingStore.loading = false;
            loaded.value = true;
        });
    }

    // 마스터 권한 변경
    const changeAdminCorpMasterYn = async (userId, masterYn) => {
        // 마스터가 있을 경우, 마스터 권한 부여 못함.
        if(masterYn === 'Y') {
            await checkCorpMasterYn();
            if(checkMasterYn.value) {
                $alert("이미 마스터 권한을 가진 회원이 있습니다.");
                return -1;
            }
        }

        let confirmMsg;
        let confirmBtn;
        if(masterYn === 'Y') {
            confirmMsg = ["회원에게 마스터 권한을 부여할까요?", "마스터 회원은 일자리/장비 매칭을 할 수 있습니다."];
            confirmBtn = '권한 부여';
        } else {
            confirmMsg = ["마스터 권한을 취소 시킬까요?", "취소하더라도 매칭 내역 정보는 삭제되지 않습니다."];
            confirmBtn = '권한 취소';
        }
        const ok = await $confirm(confirmMsg, confirmBtn);

        if(!ok) {
            return -1;
        } else {
            let paramObj = {
                userId: userId,
                masterYn: masterYn,
            }
            loadingStore.loading = true;
            adminMatchingService.updateAdminCorpMasterYn(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    if (res.data.code.toLowerCase() === 'success') {
                        $alert("마스터 권한 변경을 하였습니다.");
                        retrieveCorpEmpList();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) => {
                console.log(res)
            });
        }
    }

    // 해당 기업에 마스터가 있는지 확인
    const checkCorpMasterYn = async () => {
        loadingStore.loading = true;
        await adminMatchingService.retrieveMasterYnCount(corporation.value.corpId)
            .then( (res) => {
                loadingStore.loading = false;
                if (res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    checkMasterYn.value = (result > 0);
                } else {
                }
            }).catch( (res) => {
            console.log(res);
        });
    }
    // e: 재직자 가입 현황

    // s: 채용 진행 현황
    // 채용 진행 현황 조회
    const retrieveCorpMatchingList = () => {
        let paramObj = {
            corpId: corporation.value.corpId,
            searchStateGbs: _.map(searchInput3.value.stateGbsList).join(','),
            searchInterests: _.map(searchInput3.value.interestsList).join(','),
            searchMatchingGb: _.map(searchInput3.value.matchingGbList).join(','),
            searchType: searchInput3.value.searchType,
            searchInput: searchInput3.value.searchInput,
            startYmd: searchInput3.value.searchDurationType === 'all' ? '' : searchInput3.value.startYmd,
            endYmd: searchInput3.value.searchDurationType === 'all' ? '' : searchInput3.value.endYmd,
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        //loadingStore.loading = true;
        loaded.value = false;
        adminMatchingService.retrieveCorpMatchingList(paramObj)
            .then( async (res) => {
                //loadingStore.loading = false;
                await retrieveCount();
                loaded.value = true;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    corpMatchingList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            //loadingStore.loading = false;
            loaded.value = true;
        });
    }

    const retrieveCount = () => {
        let paramObj = {
            corpId: corporation.value.corpId,
            corpUserId: 0,
        }
        adminMatchingService.retrieveMatchingTotalCount(paramObj)
            .then( (res) => {
                if(res.data.code.toLowerCase() === 'success') {
                    resultCount.value = res.data.result;
                } else {
                }
            }).catch( (res) => {
            console.log(res);
        });
    }

    // 채용 상태 변경
    const changeState = (matchingGb, userId, stateGb, propId, corpId, resumeId) => {
        if(matchingGb === '01') {  // 채용 제안
            changePropState(userId, propId, stateGb);
        } else if(matchingGb === '02') {  // 인재 채용
            changeResState(resumeId, corpId, stateGb)
        }
    }

    // 채용 제안 상태 변경
    const changePropState = async (userId, propId, stateGb) => {
        let confirmMsg;
        let confirmBtn;
        if(stateGb === '02') {
            confirmMsg = ["제안서 전송이 취소(철회)됩니다.", "상태를 ‘제안취소’로 변경할까요?"];
        } else if(stateGb === '05') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 진행’으로 변경할까요?"];
        } else if(stateGb === '06') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 중단’으로 변경할까요?"];
        } else if(stateGb === '07') {
            confirmMsg = ["상태를 ‘합격’ 으로 변경할까요? "];
        } else if(stateGb === '08') {
            confirmMsg = ["상태를 ‘불합격’ 으로 변경할까요?"];
        }
        confirmBtn = "변경";

        const ok = await $confirm(confirmMsg, confirmBtn);
        if(!ok) {
            return false;
        } else {
            let paramObj = {
                propId: propId,
                userId: userId,
                propStateGb: stateGb
            };
            //console.log(paramObj);

            loadingStore.loading = true;
            mypageProposalService.changeProposalUserState(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        // const result = res.data.result;
                        $alert("변경하였습니다.");
                        retrieveCorpMatchingList();
                        // 매칭 상태 값 업데이트
                        retrieveMatchingUpdate();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) => {
                loadingStore.loading = false;
                console.log(res);
            });
        }
    };

    // 인재 채용 상태 변경
    const changeResState = async (resumeId, corpId, stateGb) => {
        let confirmMsg;
        let confirmBtn;

        if(stateGb === '02') {
            confirmMsg = ["제안서 전송이 취소(철회)됩니다.", "상태를 ‘제안취소’로 변경할까요?"];
        } else if(stateGb === '05') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 진행’으로 변경할까요?"];
        } else if(stateGb === '06') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 중단’으로 변경할까요?"];
        } else if(stateGb === '07') {
            confirmMsg = ["상태를 ‘합격’ 으로 변경할까요? "];
        } else if(stateGb === '08') {
            confirmMsg = ["상태를 ‘불합격’ 으로 변경할까요?"];
        }
        confirmBtn = "변경";
        const ok = await $confirm(confirmMsg, confirmBtn);
        if(!ok) {
            return -1;
        } else {
            let paramObj2 = {
                resumeId: resumeId,
                corpId: corpId,
                resStateGb: stateGb,
            }
            mypageProposalService.changeResumeCorporationState(paramObj2)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        //const result = res.data.result;
                        $alert("변경하였습니다.");
                        retrieveCorpMatchingList();
                        // 매칭 상태값 업데이트
                        retrieveMatchingUpdate();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) =>  {
                loadingStore.loading = false;
                console.log(res);
            });
        }
    }

    // 매칭 상태값 업데이트 (matchingUpdateStore 업데이트)
    const retrieveMatchingUpdate = async () => {
        await mypageMatchingService.retrieveMatchingUpdate()
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    matchingUpdateStore.matchingUpdate = result;
                    await matchingUpdateStore.setMatchingUpdate( result );
                    matchingUpdateStore.value = await useMatchingUpdateStore();
                }
            }).catch( (error) => {
                loadingStore.loading = false;
                console.log(error);
            });
    }

    // 기본 이력서 보기
    const showUserResumeModal = (userId) => {
        userMatchingResumeModal.value.init(false);
        userMatchingResumeModal.value.retrieveRecordDetail(userId);
        userMatchingResumeModal.value.show();
    }

    // 채용 이력서 보기
    const showMatchingResumeModal = (resumeId) => {
        userMatchingResumeModal.value.init(false);
        userMatchingResumeModal.value.retrieveUserMatchingResumeDetail(resumeId, 0);
        userMatchingResumeModal.value.show();
    }

    // 채용 제안서 보기
    const showProposalContentModal = async (propId) => {
        proposalContentModal.value.retrieveProposalContent(propId);
        await proposalContentModal.value.show();
    };

    // e: 채용 진행 현황

    // 탭 선택 이벤트
    const onSelectTab = (option) => {
        tabIndex.value = option.value;
        tabIndex2.value = 1;

        currentPage.value = 1;
        pageSize.value = 10;
        searchOpen.value = true;

        if(tabIndex.value === 1) { // 기본 정보
            retrieveCorpDetail();
            setViewMode(VIEW);
        } else if(tabIndex.value === 2) { // 재직자 가입 현황
            retrieveCorpEmpList();
        } else if(tabIndex.value === 3) { // 상시채용관 현황
            // retrieveCorpMatchingList();
            setViewMode(BASIC);
        }

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("tab", option.value);
        queryParams.set("tab2", option.value === 3 ? "job-postings" : '');
        window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
    }

    const onSelectTab2 = (option) => {
      tabIndex2.value = option.value;

      currentPage.value = 1;
      pageSize.value = 10;
      viewMode.value = BASIC;

      if(tabIndex2.value === 1) { // 채용공고 관리 및 입사지원 현황
        // retrieveCorpDetail();
      } else if(tabIndex2.value === 2) { // 관심인재
        // retrieveCorpEmpList();
      } else if(tabIndex2.value === 3) { // 보낸 면접제안
        // retrieveCorpMatchingList();
      }
    }

    // 탭 상세 화면 보기 조건
    const setViewMode = (viewName) => {
      if(viewName === UPDATE) {
        retrieveCorporation();
      }
      viewMode.value = viewName;
    }

    // 페이지 선택
    const onSelectPage = (pageNo) => {
        currentPage.value = pageNo;
        if(tabIndex.value === 2) { // 재직자 가입 현황
            retrieveCorpEmpList();
        } else if(tabIndex.value === 3) { // 상시채용관 현황
            // retrieveCorpMatchingList();
        }
    }

    // 검색조건 - 페이지 사이즈 변경. 10,30,50,100
    const onSelectPageSize = (option) => {
        pageSize.value = option.value;
        currentPage.value = 1;

        if(tabIndex.value === 2) { // 재직자 가입 현황
            retrieveCorpEmpList();
        } else if(tabIndex.value === 3) { // 상시채용관 현황
            // retrieveCorpMatchingList();
        }
    }

    // 검색조건 - 검색기준 매핑
    const onSelectSearchTypeGroup = (option) => {
        if(tabIndex.value === 2) { // 재직자 가입 현황
            searchInput2.value.searchType = option.value;
        } else if(tabIndex.value === 3) { // 상시채용관 현황
            searchInput3.value.searchType = option.value;
        }
    }

    // 검색조건 - 기간 매핑(C:가입일, L:최근 접속일), 재직자 가입 현황 tab
    const onSelectSearchDurationGbGroup = (option) => {
        searchInput2.value.searchDurationGb = option.value;
    }

    // 검색조건 - '초기화' 버튼
    const clearSearchInput = () => {
        if(tabIndex.value === 2) { // 재직자 가입 현황
            searchInput2.value = {
                desiredJobList: ['회로/시스템 설계','장비 운영/유지보수/개선','장비/부품 개발','소재 개발 및 평가','공정 개발 및 평가','패키지 개발','제품 평가 및 분석','반도체 SW 개발','기타'],
                interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                sex: '00',
                corpMasterYn: false,
                searchType: 'name', // code 회원코드,name 이름, id 아이디, email 이메일
                searchInput: '',
                searchDurationGb: 'C', // (C 가입일 L 최근 접속일 )
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
            }
            desiredJobListRef.value.initOptions();
            interestsListRef2.value.initOptions();
        }
    }

    // 검색조건 - '검색' 버튼
    const onClickSearch = () => {
        currentPage.value = 1;
        if(tabIndex.value === 2) { // 재직자 가입 현황
            retrieveCorpEmpList();
        }
    }

    // 목록 버튼
    const goBack = () => {
      router.push({name: 'CorporationList'})
    }

    //무결성 검사
    const validateText = (key, value) => {
      if (key === 'bizNum') {
        errorInputCorp.value.bizNum = !value ? '사업자등록번호를 입력하세요.' : '';
      } else if (key === 'corpName') {
        errorInputCorp.value.corpName = !value ? '기업명을 입력하세요.' : '';
      } else if (key === 'ceoName') {
        errorInputCorp.value.ceoName = !value ? '대표자명을 입력하세요.' : '';
      } else if (key === 'bizType') {
        errorInputCorp.value.bizType = !value ? '업종을 입력하세요.' : '';
      } else if (key === 'foundYm') {
        errorInputCorp.value.foundYm = !value ? '창립연월을 입력하세요.' : '';
      } else if (key === 'recruitCnt') {
        errorInputCorp.value.recruitCnt = !value ? '모집인원을 입력하세요.' : '';
      } else if (key === 'chargeName') {
        errorInputCorp.value.chargeName = !value ? '성명을 입력하세요.' : '';
      } else if (key === 'chargeDepart') {
        errorInputCorp.value.chargeDepart = !value ? '부서를 입력하세요.' : '';
      } else if (key === 'chargeJob') {
        errorInputCorp.value.chargeJob = !value ? '직위를 입력하세요.' : '';
      } else if (key === 'chargeCompanyNum') {
        errorInputCorp.value.chargeCompanyNum = !value ? '회사 직통번호를 입력하세요.' : '';
      } else if (key === 'chargePhoneNum') {
        errorInputCorp.value.chargePhoneNum = !value ? '휴대폰 번호를 입력하세요.' : '';
      } else if (key === 'chargeEmail') {
        errorInputCorp.value.chargeEmail = !value ? '이메일을 입력하세요.' : '';
      }
    }

    // 이력서 보기
    const onClickMyResume = (resumeId) => {
      jobFairResumeModal.value.init(false);
      jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId.value);
      jobFairResumeModal.value.show();
    }

    // 채용공고 보기
    const onClickJobNotice = async (jobNoticeSeq, corpId) => {
      jobNoticeModal.value.init(false, false, false, ojfId.value);
      jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
      jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId.value, corpId);
      jobNoticeModal.value.retrieveCorporation(corpId);
      await jobNoticeModal.value.show();
    }
</script>

<template>
    <div class="container">
        <div class="flex-wrap admin">
            <SNBAdmin class="snb" />
            <div class="content">
                <div class="sub-title">
                    <h3>{{ corporation.corpName }} 기업 정보</h3>
                </div>
                <div class="btn-wrap space-between mb-xs">
                    <div>
                        <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
                    </div>
                </div>
                <KSATab 
                  ref="tabRef"
                  style="grid-template-columns: repeat(3, 1fr);"
                  class="mb-lg"
                  :options="tabOptions"
                  @change="onSelectTab"
                />

                <!-- s: 기본 정보 -->
                <loading
                    :active="!loaded"
                    loader="dots"
                    color="#3843AF"
                    opacity="0.5"
                    width="35"
                    :is-full-page="false"></loading>
                <div v-show="tabIndex === 1 && loaded">
                  <div v-if="viewMode === VIEW">
                    <div class="table-form">
                        <table class="vertical">
                            <colgroup>
                                <col width="200px" />
                                <col />
                                <col width="200px" />
                                <col />
                            </colgroup>
                            <tr>
                                <th>최초 등록일</th>
                                <td>{{ $yyyymmddHHmmss(corporation.createDate) }}</td>
                                <th>최근 수정일</th>
                                <td>{{ $yyyymmddHHmmss(corporation.modifyDate) }}</td>
                            </tr>
                            <tr>
                                <th>로고이미지(CI)</th>
                                <td colspan="3">
                                    <div v-if="corporation.ciImgDir" style="width: 160px; height: 160px;">
                                        <KSAImage :src="corporation.ciImgDir"/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>사업자등록번호</th>
                                <td>{{ $bizNum(corporation.bizNum) }}</td>
                                <th>업종</th>
                                <td>{{ corporation.bizType }}</td>
                            </tr>
                            <tr>
                                <th>기업명</th>
                                <td>{{ corporation.corpName }}</td>
                                <th>산업군</th>
                                <td>{{ $gbNameKR('INDUSTRY_GB', corporation.industryGb) }}</td>
                            </tr>
                            <tr>
                                <th>대표자명</th>
                                <td>{{ corporation.ceoName }}</td>
                                <th>기업형태</th>
                                <td>{{ $gbNameKR('CORP_GB', corporation.corpGb) }}</td>
                            </tr>
                            <tr>
                                <th>창립연월</th>
                                <td>{{ $yyyymm(corporation.foundYm) }}</td>
                                <th>상장여부</th>
                                <td>{{ corporation.corpPublicYn === 'Y' ? '상장' : '비상장' }}</td>
                            </tr>
                            <tr>
                                <th>사원수</th>
                                <td>{{ $gbNameKR('EMPLOYEE_NUM_GB', corporation.employeeNumGb) }}</td>
                                <th>매출액</th>
                                <td>{{ $gbNameKR('SALES_AMT_GB', corporation.salesAmtGb) }}</td>
                            </tr>
                            <tr>
                                <th>사업장소재지</th>
                                <td colspan="3">{{ corporation.residenceArea1 }} {{ corporation.residenceArea2 }}</td>
                            </tr>
                            <tr>
                                <th>홈페이지 URL</th>
                                <td colspan="3">{{ corporation.homeUrl }}</td>
                            </tr>
                            <tr>
                                <th>사업자등록증</th>
                                <td colspan="3">
                                    <KSATextButton v-if="corporation.bizLicenseDir" class="ml-xs" :text=corporation.bizLicenseName @click="$downloadForPrivate({fileName:corporation.bizLicenseName, fileDir: corporation.bizLicenseDir})" />
                                </td>
                            </tr>
                            <tr>
                                <th>기업 소개서</th>
                                <td colspan="3">
                                    <KSATextButton v-if="corporation.corpIntroDir" class="ml-xs" :text=corporation.corpIntroName @click="$downloadForPrivate({fileName:corporation.corpIntroName, fileDir: corporation.corpIntroDir})" />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <br>
                    <div class="table-form word-break-all">
                        <table class="vertical">
                            <colgroup>
                                <col width="200px" />
                                <col />
                            </colgroup>
                            <tr>
                                <th>기업소개</th>
                                <td colspan="3">
                                  <div class="board-detail">
                                    <div class="body">
                                      <div class="text" v-html="corporation.corpIntro"></div>
                                    </div>
                                  </div>
                                </td>
                            </tr>
                            <tr>
                                <th>주요 연혁</th>
                                <td colspan="3">
                                  <div class="board-detail">
                                    <div class="body">
                                      <div class="text" v-html="corporation.corpHistory"></div>
                                    </div>
                                  </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="table-form mt-md">
                      <table class="vertical">
                        <colgroup>
                          <col width="200px" />
                          <col />
                          <col width="200px" />
                          <col />
                        </colgroup>
                        <tr>
                          <th colspan="4">담당자 정보</th>
                        </tr>
                        <tr>
                          <th>성명</th>
                          <td>{{ corporation.chargeName }}</td>
                          <th>부서</th>
                          <td>{{ corporation.chargeDepart }}</td>
                        </tr>
                        <tr>
                          <th>직위</th>
                          <td>{{ corporation.chargeJob }}</td>
                          <th>회사 직통번호</th>
                          <td>{{ corporation.chargeCompanyNum }}</td>
                        </tr>
                        <tr>
                          <th>휴대전화</th>
                          <td>{{ corporation.chargePhoneNum }}</td>
                          <th>이메일</th>
                          <td>{{ corporation.chargeEmail }}</td>
                        </tr>
                      </table>
                    </div>
                    <div class="udt-button-wrapper">
                      <KSASecondaryButton class="gray_button" text="수정" @click="setViewMode(UPDATE)" />
                    </div>
                  </div>
                  <!-- S : 기업정보 관리 수정 -->
                  <div class="table-form" v-if="viewMode === UPDATE">
                    <!-- s : 기업 기본 정보 -->
                    <div class="table-form mt-sm">
                      <table class="vertical align-left">
                        <colgroup>
                          <col width="20%" />
                          <col />
                        </colgroup>
                        <tr>
                          <th colspan="2">기업 기본 정보</th>
                        </tr>
                        <tr>
                          <th class="mark">사업자등록번호</th>
                          <td>
                            <KSAInput class="text-box" @input="formatBizNum" v-model="corpUpdate.bizNum" maxLength="15" placeholder="10자리 숫자 입력" />
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.bizNum }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">기업명</th>
                          <td>
                            <KSAInput class="text-box" @input="validateText('corpName', $event.target.value)" v-model="corpUpdate.corpName" maxLength="500" />
                            <div>
                              <small style="color:#E71414;">{{errorInputCorp.corpName }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">대표자명</th>
                          <td>
                            <KSAInput class="text-box" @input="validateText('ceoName', $event.target.value)" v-model="corpUpdate.ceoName" maxLength="50" placeholder="대표명을 입력하세요." />
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.ceoName }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">사업장소재지</th>
                          <td>
                            <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.residenceArea }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">업종</th>
                          <td>
                            <KSAInput class="text-box" v-model="corpUpdate.bizType" @input="validateText('bizType', $event.target.value)" maxLength="100 " placeholder="업종을 입력하세요." />
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.bizType }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">산업군</th>
                          <td>
                            <template v-for="option in $gb.INDUSTRY_GB">
                              <KSARadioButton class="check-box mr-md" name="industryGb" :label="option.label" v-model="corpUpdate.industryGb" :value="option.value" @change="resetIndustryText(option.value)" />
                              <div class="etc-box" v-if="option.label === '기타' && corpUpdate.industryGb == option.value" >
                                <KSAInput class="text-box" v-model="corpUpdate.industryText" placeholder="기타 산업군을 입력하세요." />
                              </div>
                            </template>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.industryGb }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">기업형태</th>
                          <td>
                            <template v-for="option in $gb.CORP_GB">
                              <KSARadioButton class="check-box mr-sm" name="corpGb" :label="option.label" v-model="corpUpdate.corpGb" :value="option.value" @change="resetCorpText(option.value)"/>
                              <div class="etc-box" v-if="option.label === '기타' && corpUpdate.corpGb == option.value" >
                                <KSAInput class="text-box" v-model="corpUpdate.corpText" placeholder="기타 기업형태를 입력하세요." />
                              </div>
                            </template>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.corpGb }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">창립연월</th>
                          <td>
                            <KSAInputDateYYYYMM class="text-box" v-model="corpUpdate.foundYm" @input="validateText('foundYm', $event.target.value)" placeholder="YYYY.MM" format="YYYYMM" max-length="5" />
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.foundYm }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">사원수</th>
                          <td>
                            <KSASelect class="select" v-model="corpUpdate.employeeNumGb" :options="[{label: '선택', value: '00'}, ...$gb.EMPLOYEE_NUM_GB]"/>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.employeeNumGb }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">매출액</th>
                          <td>
                            <KSASelect class="select" v-model="corpUpdate.salesAmtGb" :options="[{label: '선택', value: '00'}, ...$gb.SALES_AMT_GB]"/>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.salesAmtGb }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark" rowspan="2">상장여부</th>
                          <td>
                            <KSARadioButton class="check-box mr-lg" label="상장" v-model="corpUpdate.corpPublicYn" value="Y" @change="resetCorpPublic('Y')" />
                            <KSARadioButton class="check-box mr-lg" label="비상장" v-model="corpUpdate.corpPublicYn" value="N" @change="resetCorpPublic('N')" />
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.corpPublicYn }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td v-if="corpUpdate.corpPublicYn === 'Y'">
                            <template v-for="option in $gb.CORP_PUBLIC_GB">
                              <KSARadioButton class="check-box mr-sm" name="corpPublicGb" :label="option.label" v-model="corpUpdate.corpPublicGb" :value="option.value" @change="resetCorpPublicText(option.value)" />
                              <div class="etc-box" v-if="option.label === '기타' && corpUpdate.corpPublicGb == option.value" >
                                <KSAInput class="text-box" v-model="corpUpdate.corpPublicText" placeholder="기타 상장을 입력하세요." />
                              </div>
                            </template>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.corpPublicGb }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>홈페이지 URL</th>
                          <td>
                            <KSAInput class="text-box" v-model="corpUpdate.homeUrl" maxLength="200" placeholder="홈페이지 URL을 입력하세요." />
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">로고이미지(CI)</th>
                          <td class="text-box">
                            <div class="grid file">
                              <KSAPrimaryButton text="파일 선택" @click="uploadFileCiImg(corpUpdate)" />
                              <KSAInput class="input icon" v-model="corpUpdate.ciImgName" placeholder="파일 선택(가로 75px X 세로 40px 사이즈 이미지를 권장합니다.)" disabled />
                              <button class="delete" @click="removeFileCiImg(corpUpdate)"><i></i></button>
                            </div>
                            <small>최대 200MB 까지 첨부 가능</small>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.ciImg }}</small>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">사업자등록증</th>
                          <td class="text-box">
                            <div class="grid file">
                              <KSAPrimaryButton text="파일 선택" @click="uploadFileBizLicense(corpUpdate)" />
                              <KSAInput class="input icon" v-model="corpUpdate.bizLicenseName" placeholder="파일 선택" disabled />
                              <button class="delete" @click="removeFileBizLicense(corpUpdate)"><i></i></button>
                            </div>
                            <small>최대 200MB 까지 첨부 가능</small>
                            <div>
                              <small style="color:#E71414;">{{ errorInputCorp.bizLicense }}</small>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!-- e : 기업 기본 정보 -->
                    <!-- s : 기업 추가 정보 -->
                    <div class="table-form mt-sm">
                      <table class="vertical align-left">
                        <colgroup>
                          <col width="20%" />
                          <col />
                        </colgroup>
                        <tr>
                          <th colspan="2">기업 추가 정보</th>
                        </tr>
                        <tr>
                          <th>기업 소개</th>
                          <td>
                            <KSACKEditor ref="corpIntroEditorRef" v-model="corpUpdate.corpIntro" />
                          </td>
                        </tr>
                        <tr>
                          <th>주요 연혁</th>
                          <td>
                            <KSACKEditor ref="corpHistoryEditorRef" v-model="corpUpdate.corpHistory" />
                          </td>
                        </tr>
                        <tr>
                          <th>기업 소개서</th>
                          <td class="text-box">
                            <div class="grid file">
                              <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntro(corpUpdate)" />
                              <KSAInput class="input icon" v-model="corpUpdate.corpIntroName" placeholder="파일 선택" disabled />
                              <button class="delete" @click="removeFileCorpIntro(corpUpdate)"><i></i></button>
                            </div>
                            <small>최대 200MB 까지 첨부 가능</small>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!-- e : 기업 추가 정보 -->
                    <!-- s : 담당자 정보 -->
                    <div class="table-form mt-sm">
                      <table class="vertical align-left">
                        <colgroup>
                          <col width="20%" />
                          <col />
                        </colgroup>
                        <tr>
                          <th colspan="2">담당자 정보</th>
                        </tr>
                        <tr>
                          <th class="mark">성명</th>
                          <td>
                            <KSAInput class="text-box" v-model="corpUpdate.chargeName" @input="validateText('chargeName')" maxLength="10" placeholder="성명을 입력하세요." />
                            <p>
                              <small style="color:#E71414;">{{ errorInputCorp.chargeName }}</small>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">부서</th>
                          <td>
                            <KSAInput class="text-box" v-model="corpUpdate.chargeDepart" @input="validateText('chargeDepart')" maxLength="10" placeholder="부서를 입력하세요." />
                            <p>
                              <small style="color:#E71414;">{{ errorInputCorp.chargeDepart }}</small>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">직위</th>
                          <td>
                            <KSAInput class="text-box" v-model="corpUpdate.chargeJob" @input="validateText('chargeJob')" maxLength="10" placeholder="직위를 입력하세요." />
                            <p>
                              <small style="color:#E71414;">{{ errorInputCorp.chargeJob }}</small>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">회사 직통번호</th>
                          <td>
                            <KSAInput class="text-box" v-model="corpUpdate.chargeCompanyNum" @input="validateText('chargeCompanyNum')" maxLength="200" placeholder="회사 직통번호를 입력하세요. ex) 02-1234-5678" />
                            <p>
                              <small style="color:#E71414;">{{ errorInputCorp.chargeCompanyNum }}</small>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">휴대전화</th>
                          <td>
                            <KSAInputPhoneNum class="input" v-model="corpUpdate.chargePhoneNum" label="" @input="validateText('chargePhoneNum')" maxLength="200" placeholder="휴대폰 번호를 입력하세요."/>
                            <p>
                              <small style="color:#E71414;">{{ errorInputCorp.chargePhoneNum }}</small>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th class="mark">이메일</th>
                          <td>
                            <KSAInput class="text-box" v-model="corpUpdate.chargeEmail" @input="validateText('chargeEmail')" maxLength="50" placeholder="이메일 주소를 입력하세요." />
                            <p>
                              <small style="color:#E71414;">{{ errorInputCorp.chargeEmail }}</small>
                            </p>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!-- e : 담당자 정보 -->
                    <div class="btn-wrap space-between">
                      <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel" />
                      <KSASecondaryButton text="수정 완료" @click="updateCorporation" />
                    </div>
                  </div>
                  <!-- E : 기업정보 관리 수정 -->
                </div>
                <!-- e: 기본 정보 -->

                <!-- s: 재직자 가입 현황-->
                <loading
                    :active="!loaded"
                    loader="dots"
                    color="#3843AF"
                    opacity="0.5"
                    width="35"
                    :is-full-page="false"></loading>
                <div v-if="tabIndex === 2 && loaded">
                    <!-- s: 검색 -->
                    <div class="filter-wrap" :class="{'open': searchOpen}">
                        <p @click="searchOpen = !searchOpen">검색</p>
                        <div class="filter">
                            <dl >
                                <dt style="display:block;"><span>직무</span><br><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="desiredJobListRef"
                                        className="mr-md"
                                        name="desiredJobList"
                                        v-model="searchInput2.desiredJobList"
                                        :options="desiredJob" />
                                  </dd>
                            </dl>
                            <dl>
                                <dt style="display:block;"><span>관심 카테고리</span><br><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="interestsListRef2"
                                        className="mr-md"
                                        name="interestsList"
                                        v-model="searchInput2.interestsList"
                                        :options="interests" />
                                </dd>
                            </dl>
                            <dl>
                                <dt>성별</dt>
                                <dd>
                                    <template v-for="group in sexGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput2.sex" :value="group.value" />
                                    </template>
                                </dd>
                            </dl>
                            <dl>
                                <dt>마스터 회원</dt>
                                <dd>
                                    <KSACheckBox label="마스터 회원 보기" v-model="searchInput2.corpMasterYn" />
                                </dd>
                            </dl>
                            <!-- 재직자명,아이디,핸드폰번호뒷자리,이메일 검색 -->
                            <dl>
                                <dt>
                                    <KSASelect :options="searchTypeGroup2" class="select" @selectOption="onSelectSearchTypeGroup"/>
                                </dt>
                                <dd>
                                    <KSAInput class="text-box" v-model="searchInput2.searchInput" :placeholder="searchInputPlaceholder2" />
                                </dd>
                            </dl>
                            <!-- 가입일,최근 접속일,모든기간,기간검색 -->
                            <dl>
                                <dt>
                                    <KSASelect ref="searchDurationGbRef2" :options="searchDurationGbGroup" class="select" @selectOption="onSelectSearchDurationGbGroup"/>
                                </dt>
                                <dd class="text-box">
                                    <div class="grid">
                                        <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                            <KSARadioButton class="mr-md" name="searchDurationGb2" :label="group.label" v-model="searchInput2.searchDurationType" :value="group.value" />
                                        </template>
                                        <div style="display: inline-block;" v-show="searchInput2.searchDurationType !== 'all'">
                                            <KSADatepickerTerms
                                                :startDate="searchInput2.startYmd"
                                                :endDate="searchInput2.endYmd"
                                                @update:startDate="(value)=> searchInput2.startYmd = value"
                                                @update:endDate="(value)=> searchInput2.endYmd = value"
                                            />
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <div class="btn-wrap">
                                <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                                <KSAPrimaryButton text="검색" @click="onClickSearch" />
                            </div>
                        </div>
                    </div>
                    <!-- e: 검색 -->
                    <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>명</p>
                        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                    </div>
                    <div class="table-form">
                        <table class="horizontal" v-if="corpEmpList !== null">
                            <tr>
                                <th>NO</th>
                                <th>가입일</th>
                                <th>최근 접속일</th>
                                <th>재직자명</th>
                                <th>아이디</th>
                                <th>핸드폰번호</th>
                                <th>이메일</th>
                                <th>마스터구분</th>
                                <th>마스터 권한 변경</th>
                            </tr>
                            <tr v-for="corpEmp in corpEmpList">
                                <td>{{ corpEmp.boardNo }}</td>
                                <td>{{ $yyyymmddHHmmss(corpEmp.createDate) }}</td>
                                <td>{{ $yyyymmddHHmmss(corpEmp.lastLoginDate) }}</td>
                                <td class="link text">
                                    <RouterLink :to="{name:'MemberDetail', params:{id: corpEmp.userId}}">{{ corpEmp.userName }}</RouterLink>
                                </td>
                                <td>{{ corpEmp.userLoginId }}</td>
                                <td>{{ $phoneNum(corpEmp.phoneNum) }}</td>
                                <td>{{ corpEmp.email }}</td>
                                <td>
                                    <span v-if="corpEmp.corpMasterYn === 'Y'">마스터</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <span v-if="corpEmp.corpMasterYn === 'Y'" @click="changeAdminCorpMasterYn(corpEmp.userId, '')" class="link text" style="color: red;">[마스터 권한 취소]</span>
                                    <span v-else @click="changeAdminCorpMasterYn(corpEmp.userId, 'Y')" class="link text">[마스터 권한 부여]</span>
                                </td>
                            </tr>
                        </table>
                        <div class="result-none" v-if="corpEmpList.length === 0">
                            가입한 재직자가 없습니다.
                        </div>
                        <Paginate
                            v-if="corpEmpList.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                        />
                    </div>
                </div>
                <!-- e: 재직자 가입 현황 -->

                <!-- s : 상시채용관 현황 -->
                <loading
                    :active="!loaded"
                    loader="dots"
                    color="#3843AF"
                    opacity="0.5"
                    width="35"
                    :is-full-page="false"></loading>
                <div v-if="false &&tabIndex === 3 && loaded">
                    <KSATab style="grid-template-columns: repeat(3, 1fr);" class="mt-n-sm mb-lg"
                            :options="[
                              {label:'채용공고 관리 및 입사지원 현황', value:1},
                              {label:'관심인재', value:2},
                              {label:'보낸 면접제안', value:3},
                          ]"
                            @change="onSelectTab2"
                    />
                    <!-- s: tabIndex2 1 채용공고 관리 및 입사지원 현황 -->
                    <div v-if="tabIndex2 === 1">
                        <div v-show="viewMode === BASIC">
                          <div class="list-top">
                            <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                            <div>
                              <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                            </div>
                          </div>
                          <div class="table-form">
                            <table class="horizontal" v-if="corpList1 !== null">
                              <tr>
                                <th>NO</th>
                                <th>채용상태</th>
                                <th>채용공고 제목</th>
                                <th>입사지원</th>
                                <th>채용기간</th>
                                <th>최근 수정일</th>
                                <th>등록일</th>
                                <th>마스터</th>
                                <th>관리</th>
                              </tr>
                              <tr v-for="ojf in corpList1">
                                <td>{{ ojf.boardNo }}</td>
                                <td>{{ ojf.state }}</td>
                                <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                                <td class="clickable blue" @click="setViewMode(RETRIEVE_APPLICANT, ojf.jobNoticeSeq, ojf.corpId, ojf.fileYn)">{{ ojf.applicantCnt }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                <td class="clickable blue">
                                  <RouterLink :to="{name:'MemberDetail', params:{id: ojf.createId}}">{{ ojf.userName }}</RouterLink>
                                </td>
                                <td>
                                  <!-- 승인/반려 처리 이전 = 수정가능, 삭제 불가 -->
                                  <!-- 승인처리 이후 + 입사지원 없는 경우 = 수정가능, 삭제 가능 -->
                                  <div v-if="ojf.modifyYn === 'Y'">
                                    <KSATextButton class="clickable" text="수정" @click="onClickJobNoticeUpdate(ojf.jobNoticeSeq)"/>
                                  </div>
                                  <div v-if="ojf.deleteYn === 'Y'">
                                    <KSATextButton class="clickable red_button" text="삭제" @click="onClickDelete(ojf.jobNoticeSeq)"/>
                                  </div>
                                  <div v-if="ojf.modifyYn === 'N' && ojf.deleteYn === 'N'"> - </div>
                                </td>
                              </tr>
                            </table>
                            <div class="result-none" v-if="corpList1.length === 0">
                              등록된 채용공고가 없습니다.
                            </div>
                          </div>
                          <Paginate
                            v-if="corpList1.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                          />
                        </div>
                        <!-- s: tabIndex2 1 채용공고 관리 및 입사지원 현황 - 입사지원 -->
                        <div v-if="viewMode === RETRIEVE_APPLICANT">
                          <KSASecondaryButton text="이전" @click="setViewMode(BASIC)" />
                          <div class="list-top">
                            <p>총 <span>{{ $number(totalCount)}}</span>명</p>
                            <div>
                              <KSAPrimaryButton text="채용공고 보기" @click="onClickJobNotice(detailCommonId, detailCommonData)" />
                            </div>
                          </div>
                          <div class="table-form">
                            <table class="horizontal" v-if="applicantList !== null">
                              <tr>
                                <th>NO</th>
                                <th>회원코드</th>
                                <th>이름</th>
                                <th>아이디</th>
                                <th>이력서 제목</th>
                                <th v-show="detailCommonData2 === 'N'">관심 카테고리</th>
                                <th>전공계열(주전공)</th>
                                <th>입사 지원일</th>
                                <th>상태</th>
                                <th>상태변경</th>
                              </tr>
                              <tr v-for="ojf in applicantList">
                                <td>{{ ojf.boardNo }}</td>
                                <td>{{ ojf.userCd }}</td>
                                <td class="clickable blue">
                                  <RouterLink :to="{name: 'MemberDetail', params:{id: ojf.userCd}}">{{ ojf.userName }}</RouterLink>
                                </td>
                                <td>{{ ojf.userLoginId }}</td>
                                <td class="text-overflow long-overflow">
                                  <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                    {{ resumeAttaches.fileName }}
                                  </span>
                                  <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                    {{ ojf.title }}
                                  </span>
                                </td>
                                <td>{{ ojf.interests }}</td>
                                <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                <td>
                                  <span v-if="ojf.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                  <span v-else-if="ojf.applyStateGb === '03'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                  <span v-else-if="ojf.applyStateGb === '04'" class="red">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                  <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                </td>
                                <td>
                                  <div v-if="ojf.applyStateGb === '01'">
                                    <KSATextButton class="clickable blue_button" text="서류합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '03')"/>
                                    &nbsp;
                                    <KSATextButton class="clickable red_button" text="불합격" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '04')"/>
                                  </div>
                                  <div v-else>
                                    -
                                  </div>
                                </td>
                              </tr>
                            </table>
                            <div class="result-none" v-if="applicantList.length === 0">
                              입사지원 내역이 없습니다.
                            </div>
                          </div>
                          <Paginate
                            v-if="applicantList.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                          />
                        </div>
                        <!-- e: tabIndex2 1 채용공고 관리 및 입사지원 현황 - 입사지원 -->
                    </div>
                    <!-- e: tabIndex2 1 채용공고 관리 및 입사지원 현황 -->
                    <!-- s: tabIndex2 2 괌심인재 -->
                    <div v-if="tabIndex2 === 2">
                      <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                        <div>
                          <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                        </div>
                      </div>
                      <div class="table-form">
                        <table class="horizontal" v-if="corpList2 !== null">
                          <tr>
                            <th>NO</th>
                            <th>회원코드</th>
                            <th>이름</th>
                            <th>아이디</th>
                            <th>이력서 제목</th>
                            <th>관심 카테고리</th>
                            <th>전공계열(주전공)</th>
                            <th>등록일</th>
                            <th>등록 마스터</th>
                          </tr>
                          <tr v-for="ojf in corpList2">
                            <td>{{ ojf.boardNo }}</td>
                            <td class="clickable blue">{{ ojf.code }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td>{{ ojf.id }}</td>
                            <td class="text-overflow long-overflow">
                              <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                {{ resumeAttaches.fileName }}
                              </span>
                              <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                {{ ojf.title }}
                              </span>
                            </td>
                            <td>{{ ojf.interests }}</td>
                            <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                            </td>
                          </tr>
                        </table>
                        <div class="result-none" v-if="corpList2.length === 0">
                          관심인재 내역이 없습니다.
                        </div>
                      </div>
                      <Paginate
                        v-if="corpList2.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                      />
                    </div>
                    <!-- e: tabIndex2 2 괌심인재 -->
                    <!-- s: tabIndex2 3 보낸 면접제안 -->
                    <div v-if="tabIndex2 === 3">
                      <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                        <div>
                          <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                        </div>
                      </div>
                      <div class="table-form">
                        <table class="horizontal" v-if="corpList3 !== null">
                          <tr>
                            <th>NO</th>
                            <th>회원코드</th>
                            <th>이름</th>
                            <th>아이디</th>
                            <th>이력서 제목</th>
                            <th>관심 카테고리</th>
                            <th>전공계열(주전공)</th>
                            <th>면접제안 공고 제목</th>
                            <th>마스터</th>
                            <th>제안일</th>
                            <th>상태</th>
                            <th>상태 변경</th>
                          </tr>
                          <tr v-for="ojf in corpList3">
                            <td>{{ ojf.boardNo }}</td>
                            <td class="text-overflow long-overflow">
                              <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                {{ resumeAttaches.fileName }}
                              </span>
                              <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                {{ ojf.title }}
                              </span>
                            </td>
                            <td>{{ ojf.interests }}</td>
                            <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                            <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td>
                              <span v-if="ojf.intvPropStateGb === '01'">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                              <span v-else-if="ojf.intvPropStateGb === '02'" class="blue">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                              <span v-else-if="ojf.intvPropStateGb === '03'" class="red">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                              <span v-else class="gray">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',ojf.intvPropStateGb) }}</span>
                            </td>
                            <td>
                              <div v-if="ojf.intvPropStateGb === '01'">
                                <KSATextButton text="제안수락" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '02')" class="clickable"></KSATextButton>
                                ,
                                <KSATextButton text="제안거절" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '03')" class="clickable red_button"></KSATextButton>
                              </div>
                              <div v-else>-</div>
                            </td>
                          </tr>
                        </table>
                        <div class="result-none" v-if="corpList3.length === 0">
                          보낸 면접제안 내역이 없습니다.
                        </div>
                      </div>
                      <Paginate
                        v-if="corpList3.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                      />
                    </div>
                    <!-- e: tabIndex2 3 보낸 면접제안 -->
                </div>
                <div v-if="tabIndex === 3 && loaded">
                  <CorpJobFairTabView />
                </div>
                <!-- e: 상시채용관 현황 -->
            </div>
        </div>
    </div>
    <MypageProposalContentModal ref="proposalContentModal"/>
    <MyPageResumeModal ref="userMatchingResumeModal"/>
    <JobFairJobNoticeModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
    <JobFairResumeModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    .textarea-box {
        height: 100px;
    }

    .blue {
        color: $blue_color;
    }

    .table-form {
        table {
            &.vertical {
                &.align-left {
                    th {
                        text-align: left;
                        span {
                            display: block;
                            font-size: $font-size_xs;
                            color: $gray_color;
                            font-weight: normal;
                        }
                    }
                }
            }
        }
        .clickable {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .udt-button-wrapper{
      text-align: right;
      margin-top: 20px;
    }
    .board-detail {
      * {
        width: 100%;
      }
      .body {
        border-bottom: 0;
        .text {
          padding: 0;
        }
      }
    }
</style>
